
const ua = navigator.userAgent
const isAndroidApp = ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;

import { Options, Vue } from "vue-class-component";
import { getReCommendQuestion, getSettingsList } from "@/api/index";
import mobileNativeSDK from '@/assets/js/mobileNativeSDK.js'
import QuestionDetail from "../components/QuestionDetail.vue"
import CloseRecommend from "../components/CloseRecommend.vue"
import { isNewBridgeView } from '@/assets/js/utils.js'
import { getClientCommonMessage, getNryQuestionId } from '@/utils/nativeFn'
import { registerFnHandler } from '@/utils/registerFnHandler'

@Options({
  components: {
    QuestionDetail,
    CloseRecommend
  },
})
export default class RecommendList extends Vue {
  
  nry_question_id: any = '' // 测试id ac9642982d674df498d49a5bcb67afbd
  isLoading: boolean = false
  loadingStatus: number = 0
  recommendQuestions = {}
  serviceVersion: number = 0
  hasToken: boolean = false
  isIntellectRecommend: string = ''
  queryDone: boolean = false
  mounted() {
    // this.getRecommendQuestions('ac9642982d674df498d49a5bcb67afbd')
    if (isNewBridgeView()) {
      this.initNewData()
    } else {
      window['$eventBus'].addListener('receiveAndroidMsg', this.receiveAndroidMsg);
      window['$eventBus'].addListener('receiveChangeVideoIosMsg', this.receiveChangeVideoIosMsg);
      this.getNativeData()
    }
  }
  // 新的dsbridge初始化
  initNewData() {
    // 监听视频切换传递内容云id
    registerFnHandler('changeVideo', (res) => {
      console.log(res, 'new changeVideo')
      // let respones = res[0]? res[0]: {}
      this.receiveChangeVideoIosMsg(res)
    })
    this.getNewNativeData()
    let num = 0
    let timer = setInterval(() => {
      if(this.queryDone) {
        clearInterval(timer)
        return
      } else {
        this.getNewNativeData()
        num++
        if (num === 10) {
          clearInterval(timer)
        }
      }
    }, 500)
  }
  // 安卓监听消息
  receiveAndroidMsg(res) {
    let androidResult: any = JSON.parse(res)
    if (androidResult.event == 'getData') { // 监听获取数据返回
      this.detailNativeData(androidResult.dataJson)
    }
    if (androidResult.event === 'changeVideo') { // 监听调用切换题目事件
      this.changeVideo(androidResult.dataJson.nry_question_id)
    }
  }
  //监听ios消息
  receiveChangeVideoIosMsg(res) {
    this.changeVideo(res.nry_question_id)
  }
  // 重新加载
  reload() {
    location.reload()
  }
  //切换题目
  async changeVideo(nry_question_id) {
    if (!this.hasToken) {
      setTimeout(() => {
        this.changeVideo(nry_question_id)
      }, 200)
      return
    }
    if (nry_question_id && this.nry_question_id == nry_question_id) { // 返回的内容云id一致则不处理第二条通知
      return
    }
    this.nry_question_id = nry_question_id
    // 获取配置
    if (this.isIntellectRecommend == '') {
      if (this.serviceVersion > 13) {
        await this.getSettingsList()
      } else {
        this.isIntellectRecommend = '1'
      }
    }
    if (this.isIntellectRecommend != '1') {
      return
    }
    if (!nry_question_id) {
      this.loadingStatus = 1
      return
    }
    if(!this.recommendQuestions[nry_question_id]) {
      this.getRecommendQuestions(nry_question_id)
    }
  }
  // 新端获取数据
  getNewNativeData() {
    if (this.queryDone) {
        return
    }
    getClientCommonMessage({}, (res) => {
      console.log(res,'h5调用端上getClientCommonMessage')
      res.token && localStorage.setItem('tal_token', res.token)
      res.user_id && localStorage.setItem('TAL_UID_TMP', res.user_id)
      res.services_version = localStorage.setItem('service_version', res.service_version)
      this.serviceVersion = Number(res.service_version);
      this.queryDone = true
      this.hasToken = true
      getNryQuestionId((res) => {
        console.log(res, '初始化获取nry_question_id')
      })
    })
  }
  // 从端上获取数据
  getNativeData() {
    mobileNativeSDK.getData((res) => {
      if (!isAndroidApp) {
        console.log(res, '11111')
        this.detailNativeData(res)
      }
    })
  }
  // 处理端上数据
  detailNativeData(res) {
    if (res.token) {
      this.hasToken = true
    }
    if (localStorage.getItem('tal_token') !== res.token) {
      localStorage.setItem('tal_token', res.token)
    }
    if (res.service_version) {
      this.serviceVersion = Number(res.service_version)
      localStorage.setItem('service_version', res.service_version)
    }
  }
  // 获取智能推荐题目
  getRecommendQuestions(nry_question_id) {
    const data = {
      question_id: nry_question_id,
    };
    getReCommendQuestion(data).then((res) => {
      if (res.data.code !== 0) {
        this.loadingStatus = 2
        return
      }
      this.loadingStatus = 1
      if (res.data.data.list) {
        this.recommendQuestions[nry_question_id] = res.data.data.list
      }
    }).catch(err => {
      console.log(err)
      this.loadingStatus = 2
    })
  }
  // 获取用户设置信息
  getSettingsList() {
    return getSettingsList().then((res) => {
      if (res.data.code != 0 || !res.data.data || !res.data.data.is_intellect_recommend) {
        this.loadingStatus = 2
        return
      }
      this.isIntellectRecommend = res.data.data.is_intellect_recommend
      // console.log(this.isIntellectRecommend, this.temp_nry_question_id, 'this.temp_nry_question_id')
      // if (this.isIntellectRecommend == '1' && this.temp_nry_question_id) {
      //   this.changeVideo(this.temp_nry_question_id)
      // }
    }).catch((err) => {
      this.loadingStatus = 2
      console.log(err)
    })
  }
  
}
